module.exports = __webpack_public_path__ + "img/4.186dcc69.jpg";